import { configureStore } from "@reduxjs/toolkit";
import { type OrderingInfoState, orderingInfoReducer } from "./orderingInfo";
import { storeInfoReducer } from "./storeInfo";
import type { IConsumer } from "components/online_ordering/objects/IConsumer";
import authentication from "reducers/authentication";
import cart from "reducers/online_ordering/cart";
import checkout from "reducers/online_ordering/checkout";
import consumer from "reducers/online_ordering/consumer";
import deliveryAddress from "reducers/online_ordering/delivery_address";
import orderingOptions from "reducers/online_ordering/ordering_options";
import publishStatus from "reducers/online_ordering/publish_status";
import type { ICartItem } from "types/cart";
import type { ICheckoutStatusState } from "types/reducers/checkout_status";
import type { IOrderingOptionsState } from "types/reducers/ordering_options";
import type { IPaymentState } from "types/reducers/payment";
import type { StoreInfo } from "types/reducers/store_info";

// TODO implement all the states
export interface OnlineOrderingState {
  authentication?: unknown;
  cart?: {
    cartItems: ICartItem[];
  };
  checkout?: {
    status: ICheckoutStatusState;
    payment: IPaymentState;
  };
  consumer?: IConsumer;
  deliveryAddress?: unknown;
  orderingInfo: OrderingInfoState;
  orderingOptions: IOrderingOptionsState;
  publishStatus?: unknown;
  /**
   * @deprecated use useOloStoreInfo
   */
  storeInfo: StoreInfo;
}

export const onlineOrderingReducer = {
  authentication,
  cart,
  checkout,
  consumer,
  deliveryAddress,
  orderingInfo: orderingInfoReducer,
  orderingOptions,
  publishStatus,
  /**
   * @deprecated Please use `useOloStoreInfo`
   */
  storeInfo: storeInfoReducer,
};

export const configureOloStore = ({
  preloadedState,
}: { preloadedState?: OnlineOrderingState } = {}) => {
  return configureStore({
    reducer: onlineOrderingReducer,
    preloadedState,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        serializableCheck: false,
      });
    },
  });
};

export type OloStore = ReturnType<typeof configureOloStore>;
